// Pure helpers for the 3D preview. The preview itself runs in the sandboxed preview frame (src/frame/), never in the
// site's own pages: see src/preview-frame.ts.

import type { Manifest, Stats } from "./store.ts";

export const PREVIEW_BODY = "threedom/avatar-human";

/** Clothing that follows the humanoid rig and has a slot is previewed on a body. */
export function wornOnBody(m: Pick<Manifest, "kind" | "conventions" | "wear">): boolean {
  return m.kind === "clothing" && !!m.wear?.slot && (m.conventions ?? []).includes("thrdm.humanoid/1");
}

/** Triangles and draw calls of everything under `root` (one draw per mesh and material group). */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function measure(root: any): Stats {
  let triangles = 0;
  let drawCalls = 0;
  root.traverse((o: { isMesh?: boolean; visible?: boolean; geometry?: { index?: { count: number } | null; attributes?: { position?: { count: number } }; groups?: unknown[] } }) => {
    if (!o.isMesh || o.visible === false || !o.geometry) return;
    const g = o.geometry;
    const n = g.index ? g.index.count : (g.attributes?.position?.count ?? 0);
    triangles += Math.floor(n / 3);
    drawCalls += Math.max(1, g.groups?.length ?? 0);
  });
  return { triangles, drawCalls };
}

